import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { initSentry } from './utils/sentry';
import { flushConfirmedAnalyticsEvents, initializeAnalytics } from './utils/ga4';

// Initialize Sentry before rendering the app
initSentry();
initializeAnalytics();
flushConfirmedAnalyticsEvents();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
